<template>
  <div id="remoteFooterBox">
    <div v-if="isTW" class="footer-view">
      <!-- 媒体列表 -->
      <ul class="footer-media">
        <li
          v-for="(media, key) in medias_list"
          :key="key"
          :name="key"
          :style="{
            'background-image': `url(${media.icon})`,
          }"
        >
          <a :href="media.link" target="_blank"> </a>
        </li>
      </ul>
      <!-- logo -->
      <div class="logo-box">
        <div v-if="footer.logos.indexOf('xd') != -1" class="xd"></div>
        <div
          v-if="footer.logos.indexOf('so_funny') != -1"
          class="so_funny"
        ></div>
        <div v-if="footer.logos.indexOf('stellar') != -1" class="stellar"></div>
      </div>
      <div class="age-box">
        <div class="age"></div>
        <div class="warning" v-html="footer.warning"></div>
      </div>
      <!-- 用户协议/隐私协议 -->
      <div class="copyright" v-html="copy_right_tw"></div>
      <div class="footer-row txt">
        <a :href="footer.agreement_link" target="_blank" class="txt">
          {{ footer.agreement }}
        </a>
        &
        <a :href="footer.privacy_link" target="_blank" class="txt">
          {{ footer.privacy }}
        </a>
      </div>
    </div>
    <div v-else class="footer-container">
      <div class="center-box">
        <div class="footer-row row-1">
          <div class="footer-logo">
            <img
              src="https://website.xdcdn.net/remote-components/icons/xd-sea.svg"
              alt=""
            />
          </div>
          <div class="text">{{ copy_right }}</div>
        </div>
        <div class="footer-row row-2">
          <a
            v-if="footer.fund && footer.fund_link"
            :href="footer.fund_link"
            target="_blank"
            class="text"
          >
            {{ footer.fund }}
          </a>
          <span v-if="footer.fund && footer.fund_link" class="line">|</span>
          <a :href="footer.privacy_link" target="_blank" class="text">
            {{ footer.privacy }}
          </a>
          <span class="line">|</span>
          <a :href="footer.agreement_link" target="_blank" class="text">
            {{ footer.agreement }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OverseasCommonFooter",
  components: {},
  computed: {
    isTW() {
      return this.lang === "tw";
    },
  },
  props: {
    lang: {
      type: String,
      default: () => 'en'
    },
    footer: {
      type: Object,
      default() {
        return {
          logos: ["xd", "so_funny", "stellar"],
          copy_right: "© 2021 LTD. All Rights Reserved",
          privacy: "Privacy Policy",
          privacy_link: "https://protocol.xd.com/privacy.html",
          agreement: "End User License Agreement",
          agreement_link: "https://protocol.xd.com/agreement.html",
          fund: "",
          fund_link: "https://protocol.xd.com/fund.html",
          copy_right_tw: `版權宣告：copyright © 2022 Star Force co.,Ltd. All rights reserved
        聯繫客服：sftwcs2022@gmail.com`,
          warning: `本遊戲涉及暴力(可愛人物打鬥) 依遊戲軟體分級管理辦法分類為輔12級。

        警語：注意使用時間，避免沉迷於遊戲。遊戲內含付費商城，請斟酌消費。`,
        };
      },
    },
    medias_list: {
      type: Array,
      default() {
        return [
          {
            link: "/",
            icon: "https://website.xdcdn.net/remote-components/icons/facebook.svg",
          },
          {
            link: "/",
            icon: "https://website.xdcdn.net/remote-components/icons/youtube.svg",
          },
          {
            link: "/",
            icon: "https://website.xdcdn.net/remote-components/icons/bahamute.svg",
          },
        ];
      },
    },
  },
  data() {
    return {
      copy_right: `© 2023 LTD. All Rights Reserved`,
      copy_right_tw: `版權宣告：copyright © 2023 Star Force co.,Ltd. All rights reserved
        聯繫客服：sftwcs2022@gmail.com`
    };
  },
  created() {
    let thisYear = new Date().getFullYear();

    this.copy_right = `© ${thisYear} LTD. All Rights Reserved`;
    this.copy_right_tw = `版權宣告：copyright © ${thisYear} Star Force co.,Ltd. All rights reserved
        聯繫客服：sftwcs2022@gmail.com`;
  }
};
</script>

<style lang="scss" scoped>
$pcAutoLayout: "only screen and (min-width: 1200px)";
$pcTransformLayout: "only screen and (max-width: 1199px)";
$footerBgColor: #2f2f2f;
$mediaIconBgColor: rgb(195, 191, 178);
$fontColor: #878787;

@mixin bg_base($url: auto) {
  background-image: url($url);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

#remoteFooterBox {
  position: relative;
  width: 100%;
}

.footer-view {
  width: 100%;
  background: $footerBgColor;
  position: relative;
  height: 371px;
  overflow: hidden;
  @media #{$pcTransformLayout} {
    height: 452px;
  }
  .footer-media {
    @media #{$pcAutoLayout} {
      position: absolute;
      bottom: 221px;
      left: 75px;
    }
    @media #{$pcTransformLayout} {
      margin: 0 auto;
      margin-top: 50px;
    }
    transform-origin: bottom left;
    // width: 240px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    li {
      width: 40px;
      background-color: $mediaIconBgColor;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-position: center;
      background-repeat: no-repeat;
      margin-right: 10px;
      a {
        width: 100%;
        height: 100%;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .logo-box {
    display: flex;
    align-items: center;
    @media #{$pcAutoLayout} {
      justify-content: center;
      position: absolute;
      right: 75px;
      bottom: 225px;
    }
    @media #{$pcTransformLayout} {
      width: 296px;
      justify-content: center;
      margin: 0 auto;
      border-top: 1px solid #858585;
      margin-top: 32px;
      padding-top: 20px;
    }
    .xd {
      @include bg_base(
        "https://website.xdcdn.net/remote-components/icons/xd.svg"
      );
      @media #{$pcAutoLayout} {
        width: 132px;
        height: 55px;
        margin-right: 14px;
      }
      @media #{$pcTransformLayout} {
        width: 80px;
        height: 33px;
        margin-right: 8px;
      }
    }
    .so_funny {
      @include bg_base(
        "https://website.xdcdn.net/remote-components/icons/so_funny.svg"
      );
      @media #{$pcAutoLayout} {
        width: 132px;
        height: 55px;
        margin-right: 14px;
      }
      @media #{$pcTransformLayout} {
        width: 80px;
        height: 33px;
        margin-right: 8px;
      }
    }
    .stellar {
      @include bg_base(
        "https://website.xdcdn.net/remote-components/icons/stellar.svg"
      );
      width: 196px;
      height: 55px;
      @media #{$pcTransformLayout} {
        width: 119px;
        height: 33px;
      }
    }
  }
  .age-box {
    @media #{$pcTransformLayout} {
      width: 297px;
      height: 72.5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;
      margin-top: 37px;
    }
    .age {
      @include bg_base(
        "https://website.xdcdn.net/remote-components/icons/age.png"
      );
      @media #{$pcAutoLayout} {
        width: 90px;
        height: 90px;
        position: absolute;
        bottom: 100px;
        right: 474px;
      }
      @media #{$pcTransformLayout} {
        width: 72.5px;
        height: 72.5px;
      }
    }
    .warning {
      font-weight: 400;
      text-align: justify;
      white-space: pre-line;
      color: $fontColor;
      @media #{$pcAutoLayout} {
        font-size: 14px;
        width: 375px;
        position: absolute;
        bottom: 100px;
        right: 75px;
        line-height: 18px;
      }
      @media #{$pcTransformLayout} {
        font-size: 12px;
        line-height: 14px;
        width: 208px;
      }
    }
  }
  .copyright {
    font-weight: 400;
    white-space: pre-line;
    color: $fontColor;
    @media #{$pcAutoLayout} {
      font-size: 14px;
      line-height: 20px;

      position: absolute;
      bottom: 145px;
      left: 75px;
    }
    @media #{$pcTransformLayout} {
      margin: 0 auto;
      margin-top: 25px;
      font-size: 12px;
      line-height: 18px;
      width: 297px;
      text-align: justify;
    }
  }
  .footer-row {
    color: $fontColor;
    font-size: 14px;
    @media #{$pcAutoLayout} {
      font-weight: 400;
      line-height: 20px;
      position: absolute;
      bottom: 125px;
      left: 75px;
    }
    @media #{$pcTransformLayout} {
      margin: 0 auto;
      margin-top: 30px;
      width: 150px;
      line-height: 18px;
      display: flex;
      justify-content: space-between;
    }
    a {
      text-decoration: underline;
      color: $fontColor;
    }
  }
}
.footer-container {
  position: relative;
  z-index: 1;
  height: 60px;
  width: 100%;
  padding: 0 20px;
  background: #000;
  color: #fff;
  font-size: 12px;
  .footer-row .text {
    color: #fff;
  }
  .footer-logo {
    width: 76px;
    height: 21px;
    @media screen and (max-width: 828px) {
      width: 69px;
      height: 19px;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}

@media screen and (max-width: 828px) {
  .footer-container {
    height: 83px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    .center-box {
      width: 100%;
    }
    .footer-row {
      display: flex;
      .line {
        display: none;
      }
      &.row-1 {
        .text {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          width: 100%;
        }
      }
      &.row-2 {
        .text {
          width: 100%;
          text-align: center;
        }
        .text:first-child {
          text-align: left;
        }
        .text:last-child {
          text-align: right;
        }
      }
    }
  }
}
@media screen and (min-width: 828px) {
  .footer-container {
    display: flex;
    justify-content: center;
    .center-box {
      width: 1025px;
      display: flex;
      justify-content: space-between;
      .footer-row {
        display: flex;
        gap: 0px 10px;
        justify-content: flex-start;
        align-items: center;
        &.row-1 {
          align-items: center;
          .text {
            padding-left: 10px;
          }
        }
        &.row-2 {
          .text {
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>